(function () {
	if (window._1gif) {
		const img = new Image(1, 1);

		img.src = window._1gif;
	}
	delete window._1gif;
})();
